import React, { useContext } from "react";
import { CurrencyContext } from "../../../../../../../contexts/currency";

import { PropertyRoom } from "../../../../../../../definitions/property";

import Flex from "../../../../../../structure/Flex";

interface RoomSummaryProps {
  meta: PropertyRoom | undefined;
  count: number;
  totalNights: number;
  removeRoom: () => void;
  fetching?: boolean;
}

const RoomSummary: React.FC<RoomSummaryProps> = ({
  meta,
  count,
  totalNights,
  removeRoom,
  fetching,
}) => {
  const { formatCurrency } = useContext(CurrencyContext);

  // console.log(meta?.offer_discount, meta?.id);
  return (
    <Flex col className="w-full my-2 text-text">
      <Flex items="center" justify="between" className="w-full">
        <span className="flex-grow">
          <span className="font-medium text-base mr-1 text-dark">
            {meta?.name}
          </span>{" "}
          x {count}
        </span>
        <button
          className="text-xl flex-shrink-0 hover:text-red-500"
          onClick={removeRoom}
        >
          <i className="material-icons">delete</i>
        </button>
      </Flex>
      {fetching ? (
        <Flex items="start" justify="between" className="w-full">
          <span className="font-medium text-subtitle">Fetching price</span>
        </Flex>
      ) : (
        meta && (
          <Flex col>
            <Flex items="start" justify="between" className="w-full">
              <span>
                <span className="text-dark">
                  {formatCurrency(
                    meta.offer_discount != null && meta.offer_discount < 0
                      ? (meta.price - meta.offer_discount) / totalNights || 0
                      : meta.price / totalNights || 0
                  )}{" "}
                </span>{" "}
                x{" "}
                {totalNights > 1
                  ? `${totalNights} nights`
                  : `${totalNights} night`}
              </span>
              <span
                className={`${
                  (meta.discount != null && meta.discount > 0) ||
                  (meta.offer_discount != null && meta.offer_discount > 0)
                    ? "text-text"
                    : "text-dark"
                } font-medium text-base`}
              >
                {formatCurrency(
                  meta.offer_discount != null && meta.offer_discount < 0
                    ? meta.price - meta.offer_discount || 0
                    : meta.price || 0
                )}
              </span>
            </Flex>
            {meta.offer_discount != null && meta.offer_discount > 0 && (
              <Flex items="start" justify="between" className="w-full">
                <span className="text-green-500 font-medium">
                  Offer applied
                </span>
                <span className="text-green-500 font-medium text-base">
                  - {formatCurrency(meta.offer_discount)}
                </span>
              </Flex>
            )}
            {meta.discount != null && meta.discount > 0 && (
              <Flex items="start" justify="between" className="w-full">
                <span className="text-green-500 font-medium">
                  Coupon applied
                </span>
                <span className="text-green-500 font-medium text-base">
                  - {formatCurrency(meta.discount)}
                </span>
              </Flex>
            )}
            {((meta.discount != null && meta.discount > 0) ||
              (meta.offer_discount != null && meta.offer_discount > 0)) && (
              <Flex items="start" justify="between" className="w-full">
                <span className="text-dark font-medium"></span>
                <span className="text-dark font-medium text-base">
                  {formatCurrency(
                    meta.price -
                      (meta.discount || 0) -
                      (meta.offer_discount || 0)
                  )}
                </span>
              </Flex>
            )}
          </Flex>
        )
      )}
    </Flex>
  );
};

export default RoomSummary;
